import {ReactNode} from 'react'
import {BASE_URL} from '../../config'
import {ISelectOption} from '../../../utils/core/_model'

export const GET_USER_LIST_URL = `${BASE_URL}/api/protect/getUserByParentWithpage`
export const GET_LAST_RECHARGE_URL = `${BASE_URL}/api/protect/getLastRecharge`
export const APPROVE_USER_URL = `${BASE_URL}/api/protect/approveUserDummy`
export const UPDATE_BALANCE_URL = `${BASE_URL}/api/protect/updateBalance`

export interface UserProviderProps {
  children: ReactNode
}

export interface IUser {
  id: number
  charging_route_id: number
  userbalance: number
  username: string
  user_profile: number
  user_status: string
  userEmail: string
  userMobile: string
  user_full_name: string
  userpass?: string
  last_recharge_date?: string
  parentid: number
  createdate: string
  created_by: number
  updated_by: number
  is_clone_user: number
  api: string
  api_key: string
  iat_sender_list_id: number
  is_kyc_form_filled: number
  user_sms_text_view: number
  user_mobile_number: number
  user_create_at: string
  child_id: number
  broadcast_pulse_rate: number
  is_email_verified: string
  is_mobile_verified: string
  verification_code: string
  author_id: number
  payment_type: string
  credit_limit: number
  isP2p: '0' | '1'
}

export interface ISenderIdArray extends Array<IUser> {}

export interface ICountState {
  [key: string]: number
}

export interface IBalanceInfo {
  transactionType: string
  amount: string
  paymentMethod: string
  note: string
}

export interface ICreateUserFormValuesType {
  userType: number | null
  userTypeName: string
  name: string
  email: string
  number: string
  marginType: string
  profitPer: number
  paymentType: number | null
  paymentTypeName: string
  authorRole: number | null
  authorRoleName: string
  creditLimit: string
  profile: string
  nid: string
  trade: string
  senders: string[]
  isUpdate: boolean
  isUserP2p: '1' | '0'
}

export const initCreateUserValues: ICreateUserFormValuesType = {
  userType: 3,
  userTypeName: '',
  name: '',
  email: '',
  number: '',
  marginType: '',
  profitPer: 0,
  paymentType: null,
  paymentTypeName: '',
  authorRole: null,
  authorRoleName: '',
  creditLimit: '',
  profile: '',
  nid: '',
  trade: '',
  senders: [],
  isUpdate: false,
  isUserP2p: '0',
}

export interface ICloneUserForm {
  user_type: string | undefined | number
  user_name: string
  user_email: string
  user_contact: string
  user_nid: File | string
  user_tradelicence: File | string
  author_id: number | null
  payment_type: string
  payment_type_name: string
  credit_limit: number
  author_name: string
}

export const CloneUserFormInitialValues: ICloneUserForm = {
  user_type: '',
  user_name: '',
  user_email: '',
  user_contact: '',
  user_nid: '',
  user_tradelicence: '',
  author_id: null,
  payment_type: '',
  payment_type_name: '',
  credit_limit: 0,
  author_name: '',
}

export const paymentTypeOptions: ISelectOption[] = [
  {id: 0, value: 'Prepaid', label: 'Prepaid'},
  {id: 1, value: 'Postpaid', label: 'Postpaid'},
]
